import React, { useEffect, useState } from "react";
import "./styles/header.css";
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/logo.jpg";

const Header = () => {
  const [hideLogoImg, setHideLogoImg] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHideLogoImg(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header">
      <div className={`header-container ${hideLogoImg ? "compact" : ""}`}>
        <div className="logo">
          <a href="#home">
            <img
              src={logo}
              alt="Airflex Logo"
              className={`logo-img ${hideLogoImg ? "hidden" : ""}`}
            />
          </a>
          <a href="#home" className="tagline">
            <p>At Airflex RSA, your car is not just a car — it’s a statement.</p>
          </a>
        </div>

        <div className="social-media">
          <a href="https://wa.me/0827472013" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
          <a
            href="https://www.tiktok.com/@airflex.co.za?_t=ZM-8wH3Nrqsms1&_r=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok />
          </a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
        </div>

        <nav className="nav">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#gallery">Gallery</a>
          <a href="#download">Download App</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
